import { Col, DatePicker, Form, Input, Modal, Row } from "antd";
import * as Validation from "../../utils/helper/validation";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const AddClosedPeriod = ({ isOpen, onOk, onCancel, data, onSubmit }) => {
  const [startDate, setStartDate] = useState(null); // Store the start date
  const [form] = Form.useForm();

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };
  const handleSubmit = async () => {
    try {
      // Validate and get the form values
      const values = await form.validateFields();

      // Log or submit the values
      values.id = data ? data.id : 0;

      // Call the external submit handler
      if (onSubmit) {
        onSubmit(values);
      }

      // Reset the form
      form.resetFields();
      onOk();
    } catch (error) {
      console.error("Form validation failed:", error);
    }
  };

  useEffect(() => {
    if (data) {
      // && data != null && data.length > 0
      form.setFieldValue("start_date", dayjs(data?.startDate, "YYYY-MM-DD"));
      form.setFieldValue("end_date", dayjs(data?.endDate, "YYYY-MM-DD"));
      form.setFieldValue("description", data?.description);
    } else {
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <Modal
        title={data ? "Edit Closed Period" : "Add Closed Period"}
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={handleSubmit}
        okText="Save"
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Start Date"
                name="start_date"
                rules={[
                  {
                    required: true,
                    message: "Please enter the start date",
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  className="h-[39px] w-full"
                  disabledDate={(current) => {
                    // Disable dates before today
                    return current && current < new Date();
                  }}
                  onChange={(date, dateString) => {
                    setStartDate(date);
                    form.setFieldValue("start_date", date);
                    handleInputChange("start_date");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="End Date"
                name="end_date"
                rules={[
                  {
                    required: true,
                    message: "Please enter the end date",
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  className="h-[39px] w-full"
                  disabledDate={(current) => {
                    // Disable dates before today and dates before the selected start date
                    return (
                      current &&
                      (current < new Date() ||
                        (startDate && current < startDate))
                    );
                  }}
                  onChange={(date) => {
                    form.setFieldValue("end_date", date);
                    handleInputChange("end_date");
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: true,
                type: "string",
                message: "Please enter your description.",
              },
            ]}
          >
            <Input
              size="large"
              maxLength={80}
              onChange={(e) => {
                form.setFieldValue("description", e.target.value.trimStart());
                handleInputChange("description");
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddClosedPeriod;
